module.exports = __webpack_public_path__ + "static/img/bottom.61b6c286.jpg";